import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Auth guard to protect routes requiring authentication
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if this is an anonymous login or member login with custom JWT
  const isAnonymousLogin = localStorage.getItem('anonymous_login') === 'true';
  const isMemberLogin = localStorage.getItem('member_login') === 'true';

  // If anonymous or member login with our JWT, allow access immediately
  if (isAnonymousLogin || isMemberLogin) {
    return true;
  }

  return authService.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        // Redirect to anonymous login page instead of triggering Auth0
        router.navigate(['/']);
        return false;
      }
      return true;
    })
  );
};
